import { createAction } from "redux-actions";

export const TEMPLATE_ACTION = "TEMPLATE_ACTION";

export const templateAction = createAction(TEMPLATE_ACTION);
